module.exports = {"id":"203486","name":"Thorgan Hazard","rating":"82","photo":"./data/images/photos/4/203486.png","club":{"name":"Bor. M'gladbach","logo":"./data/images/clubs/Bor.M'gladbach.png"},"positions":["MG","MD","ATT"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ThorganHazard0.json
// module id = 4119
// module chunks = 0